window.addEventListener('DOMContentLoaded', function() {
  window.addEventListener('scroll', function() {
    const scroll = window.pageYOffset || document.documentElement.scrollTop;
    const header = document.querySelector('sticky-header.header-wrapper');
    
    if (header) {
      if (scroll >= 10) { // 10は任意の値に変えてください
        header.classList.add('header-color');
      } else {
        header.classList.remove('header-color');
      }
    }
  });
});
